import { render } from "./LogFattureAgyo.vue?vue&type=template&id=54ed6428"
import script from "./LogFattureAgyo.vue?vue&type=script&lang=js"
export * from "./LogFattureAgyo.vue?vue&type=script&lang=js"

import "./LogFattureAgyo.vue?vue&type=style&index=0&id=54ed6428&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__